import { RootInjectorGuard } from '../guards/root-injector.guard'
import { Injectable, inject } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { ErrorService } from './error.service'
import { catchError, Observable } from 'rxjs'
import { environment } from '../../environments/environment'
import { GetDocumentResponse } from '../types/document'

@Injectable({
  providedIn: 'root',
})
export class DocumentService extends RootInjectorGuard {
  private http = inject(HttpClient)
  private errorService = inject(ErrorService)

  private URL = environment.baseUrl + 'document'

  constructor() {
    super(DocumentService)
  }

  /**
   * Retrieve document
   * @param {string} docId Id for document to retrieve
   * @returns {Observable<GetDocumentResponse>}
   */
  get(docId: string): Observable<GetDocumentResponse> {
    return this.http
      .get<GetDocumentResponse>(`${this.URL}/${docId}`)
      .pipe(catchError(this.errorService.handleError))
  }
}
